import { Component, Input } from '@angular/core';
import * as moment from 'moment-timezone';
import { Show } from 'src/app/services/api/api.service';
import { gsap, Quad } from 'gsap';
import { AddToCalendarService } from 'src/app/services/AddToCalendar/add-to-calendar.service';

@Component({
    selector: 'app-program-card',
    templateUrl: './program-card.component.html',
    styleUrls: ['./program-card.component.scss']
})
export class ProgramCardComponent {
    public tz : string
    public tzStr : string

    @Input('show') show!: Show;
    @Input('isActive') isActive: boolean = false
    @Input('isNext') isNext: boolean = false
    @Input('channel') channel: string = ''
    
    @Input('color1') color1: string;
    @Input('color2') color2: string;
    @Input('color3') color3: string;
    @Input('color4') color4: string;

    constructor(
        private addToCalendarService: AddToCalendarService
    ) {
        this.tz = this.getTZ()
        if(this.tz == '-07:00') {
            this.tzStr = 'PDT'
        }
        else {
            this.tzStr = 'PST'
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            gsap.set('.downloadButton', {backgroundColor: this.color1,  color: this.color4})
        }, 100);
    }

    getTZ() {
        const now = moment();
        const timezone = now.tz('America/Los_Angeles');
        return timezone.format('Z');
    }


    addToCalendar(show: any) {
        this.addToCalendarService.reset()

        // console.log( moment(show.start.toDate()).tz('America/Los_Angeles') )

        // var desc = this.channel + ' ' + window.location.href + '\\n' + show.description
        var desc = show.description + '\\n\\n' + '-Watch On '+ this.channel.toUpperCase() +' '

        this.addToCalendarService.addEvent(show.title, desc, "", show.start.toDate().toUTCString(), show.end.toDate().toUTCString(), window.location.href);
        this.addToCalendarService.download(show.programId, 'ics')
    }

    onCalendarOver(e: any) {
        gsap.to(e.target, 0.3, {backgroundColor: this.color2, color: this.color3, ease: Quad.easeOut});
    }


    onCalendarOut(e: any) {
        gsap.to(e.target, 0.3, {backgroundColor: this.color1, color: this.color4, ease: Quad.easeOut});
    }
}
